import { getTaskTemplate } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetTaskTemplate = (taskTemplateId: string) => {
  return useQuery(['task-template', taskTemplateId], () =>
    getTaskTemplate(taskTemplateId)
  );
};
